<template>
  <div class="mobile-order-preview">
    <mobile-device-frame
      :device-size="deviceSize"
      :background-color="theme.backgroundColor"
    >
      <div
        class="preview-content"
        :style="contentStyle"
      >
        <!-- レイアウト：左サイドバー + メインエリア -->
        <div class="preview-layout">
          <!-- サイドバー（NavigationRail） -->
          <preview-navigation-rail
            :theme="theme"
            :logo-url="logoUrl"
            :categories="categories"
            :icon-options="iconOptions"
            :selected-category-id="selectedCategoryId"
            @select-category="selectCategory"
          />

          <!-- メインエリア -->
          <div
            class="preview-main"
            :style="mainStyle"
          >
            <!-- バナー -->
            <preview-event-banner
              :banner-url="bannerUrl"
              :theme="theme"
            />

            <!-- カテゴリ名 -->
            <div
              v-if="selectedCategory"
              class="category-header"
              :style="categoryHeaderStyle"
            >
              {{ selectedCategory.vendibleTagName }}
            </div>

            <!-- 商品カード（サンプル） -->
            <div class="menu-grid">
              <preview-menu-card
                v-for="item in sampleItems"
                :key="item.id"
                :item="item"
                :theme="theme"
                @click="showProductModal(item)"
              />
            </div>
          </div>
        </div>

        <!-- 商品詳細モーダル -->
        <preview-product-modal
          v-if="selectedProduct"
          :product="selectedProduct"
          :theme="theme"
          @close="selectedProduct = null"
        />
      </div>
    </mobile-device-frame>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import MobileDeviceFrame from './MobileDeviceFrame.vue'
import PreviewNavigationRail from './preview/PreviewNavigationRail.vue'
import PreviewEventBanner from './preview/PreviewEventBanner.vue'
import PreviewMenuCard from './preview/PreviewMenuCard.vue'
import PreviewProductModal from './preview/PreviewProductModal.vue'

// サンプル商品データ
const SAMPLE_ITEMS = [
  {
    id: 1, name: 'ビール', price: 800, imageUrl: null,
  },
  {
    id: 2, name: 'ハイボール', price: 700, imageUrl: null,
  },
  {
    id: 3, name: 'カクテル', price: 900, imageUrl: null,
  },
  {
    id: 4, name: 'ワイン（グラス）', price: 1200, imageUrl: null,
  },
  {
    id: 5, name: 'シャンパン', price: 5000, imageUrl: null,
  },
  {
    id: 6, name: 'ソフトドリンク', price: 500, imageUrl: null,
  },
]

export default {
  name: 'MobileOrderPreview',

  components: {
    MobileDeviceFrame,
    PreviewNavigationRail,
    PreviewEventBanner,
    PreviewMenuCard,
    PreviewProductModal,
  },

  props: {
    deviceSize: {
      type: String,
      default: '14',
    },
    theme: {
      type: Object,
      required: true,
    },
    logoUrl: {
      type: String,
      default: null,
    },
    bannerUrl: {
      type: String,
      default: null,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    iconOptions: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const selectedCategoryId = ref(null)
    const selectedProduct = ref(null)

    // 選択中のカテゴリ
    const selectedCategory = computed(() => {
      if (!selectedCategoryId.value && props.categories.length > 0) {
        return props.categories[0]
      }

      return props.categories.find(c => c.vendibleTagId === selectedCategoryId.value)
    })

    // サンプル商品
    const sampleItems = computed(() => SAMPLE_ITEMS)

    // スタイル
    const contentStyle = computed(() => ({
      '--preview-primary': props.theme.primaryColor,
      '--preview-background': props.theme.backgroundColor,
      '--preview-card': props.theme.cardColor,
      '--preview-text': props.theme.textColor,
    }))

    const mainStyle = computed(() => ({
      backgroundColor: props.theme.backgroundColor,
    }))

    const categoryHeaderStyle = computed(() => ({
      color: props.theme.textColor,
    }))

    // カテゴリ選択
    const selectCategory = categoryId => {
      selectedCategoryId.value = categoryId
    }

    // 商品詳細モーダル表示
    const showProductModal = item => {
      selectedProduct.value = item
    }

    return {
      selectedCategoryId,
      selectedCategory,
      selectedProduct,
      sampleItems,
      contentStyle,
      mainStyle,
      categoryHeaderStyle,
      selectCategory,
      showProductModal,
    }
  },
}
</script>

<style scoped>
.mobile-order-preview {
  display: flex;
  justify-content: center;
}

.preview-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.preview-layout {
  display: flex;
  height: 100%;
}

.preview-main {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.category-header {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  padding: 4px 0;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
</style>
